// @flow
import gql from 'graphql-tag'

export const RegistrationFieldsFragment = gql`
  fragment RegistrationFields on GatheringRegistration {
    id
    gatheringId
    quantity
  }
`
